import React, { useEffect } from "react";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faFloppyDisk, faXmark } from "@fortawesome/free-solid-svg-icons";
import FloatingActions, { FloatingAction } from "../FloatingActions";
import Card from "../Card";
import axios from "axios";
import useAppData from "@/store/useAppData";
import { ListOption, stockData } from "./types";

export interface appStockCardOPProps {
    stockId?: string;
    onSave?: (stockId: string) => void;
}

const StockCardOP: React.FC<appStockCardOPProps> = ({ stockId, onSave }) => {

    const selectedModule = useAppData(state => state.selectedModule);

    const [listsState, setListsState] = React.useState<ListOption[]>([]);
    const [name, setName] = React.useState<string | null>(null);
    const [list1Value, setList1Value] = React.useState<string>("");
    const [list2Value, setList2Value] = React.useState<string>("");
    const [list3Value, setList3Value] = React.useState<string>("");
    const [useCleanersSate, setUseCleanersState] = React.useState<boolean>(true);
    const [error, setError] = React.useState<string | null>(null);

    useEffect(() => {
        setError(null);

        const loadData = async () => {
            await loadLists();

            if (stockId) {
                loadStock(stockId);
            }
        };

        loadData();
    }, []);

    const setStockData = (stock: stockData) => {
        setName(stock.name);
        setList1Value(stock.typeid1);
        setList2Value(stock.typeid2);
        setList3Value(stock.typeid3);
        setUseCleanersState(stock.usecleaners);
    }

    const loadStock = async (stockId: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/stock/get",
                    data: {
                        id: stockId
                    }
                })
            );

            if (res.data.stocks.length > 0) {
                const stock: stockData = res.data.stocks[0];
                setStockData(stock);
            }
        } catch (err) {
            throw err;
        }
    }

    const loadLists = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/listitems/getLists"
                })
            );

            if (res.data?.lists?.length > 0) {
                setListsState(res.data?.lists);
            } else {
                setListsState([]);
            }
        } catch (err) {
            throw err;
        }
    }

    const insertStock = async (name: string, useCleaners: boolean, objectId: string, list1Id: string, list2Id: string, list3Id: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/stock/insert",
                    data: {
                        name: name,
                        usecleaners: useCleaners,
                        objectid: objectId,
                        list1Id: list1Id,
                        list2Id: list2Id,
                        list3Id: list3Id,
                        module: selectedModule?.id
                    }
                })
            );

            return res.data.id;
        } catch (err) {
            throw err;
        }
    }

    const updateStock = async (idStock: string, name: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/stock/update",
                    data: {
                        id: idStock,
                        name: name
                    }
                })
            );
        } catch (err) {
            throw err;
        }
    }

    const validateNewStock = () => {
        const fn = name?.trim();
        const ln1 = list1Value?.trim?.();
        const ln2 = list2Value?.trim?.();
        const ln3 = list3Value?.trim?.();

        if (stockId) {
            if (!fn) {
                return "Vyplňte Název.";
            }
        } else {
            if (!fn || !ln1 || !ln2 || !ln3) {
                return "Vyplňte Název, Číselník 1, Číselník 2, Číselník 3.";
            }
        }

        return null;
    };

    const onCreate = async () => {
        setError(null);

        const validationError = validateNewStock();
        if (validationError) {
            setError(validationError);
            return;
        }

        if (stockId) {
            await updateStock(stockId, name);
            onSave(stockId);
        } else {

            let useCleaners = true;
            let laundryObject = "1";

            if (!useCleanersSate) {
                useCleaners = false;
                laundryObject = null;
            }

            const newStockId = await insertStock(name, useCleaners, laundryObject, list1Value, list2Value, list3Value);
            onSave(newStockId);
        }
    };

    const actions: FloatingAction[] = [
        {
            key: "cancel",
            label: "Zrušit",
            icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: () => onSave(null),
        },
        {
            key: "save",
            label: "Uložit",
            icon: <FontAwesomeIcon icon={faFloppyDisk} />,
            onClick: onCreate,
        },
    ];

    return (
        <Card title="Sklad" suppressInit={true} displaySelectedStock={false}>
            <div className="nec-stack">
                <>
                    <div className="nec-block">
                        <div className="nec-header">Název</div>
                        <div className="nec-control">
                            <input
                                className="nec-input"
                                value={name}
                                required
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Název..."
                            />
                        </div>
                    </div>


                    <div className="nec-block">
                        <div className="nec-header">Číselník 1</div>
                        <div className="nec-control">
                            <select
                                className="stock-item-control1"
                                value={String(list1Value)}
                                disabled={stockId != null && stockId != ""}
                                onChange={(e) => { setList1Value(e.target.value); }}
                            >
                                <option value="" disabled hidden>
                                    Vyberte…
                                </option>

                                {listsState.map((o) => (
                                    <option key={o.id} value={o.id}>
                                        {o.name}
                                    </option>
                                ))}
                            </select>

                        </div>
                    </div>

                    <div className="nec-block">
                        <div className="nec-header">Číselník 2</div>
                        <div className="nec-control">
                            <select
                                className="stock-item-control1"
                                value={list2Value}
                                disabled={stockId != null && stockId != ""}
                                onChange={(e) => { setList2Value(e.target.value); }}
                            >
                                <option value="" disabled hidden>
                                    Vyberte…
                                </option>

                                {listsState.map((o) => (
                                    <option key={o.id} value={o.id}>
                                        {o.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="nec-block">
                        <div className="nec-header">Číselník 3</div>
                        <div className="nec-control">
                            <select
                                className="stock-item-control1"
                                value={list3Value}
                                disabled={stockId != null && stockId != ""}
                                onChange={(e) => { setList3Value(e.target.value); }}
                            >
                                <option value="" disabled hidden>
                                    Vyberte…
                                </option>

                                {listsState.map((o) => (
                                    <option key={o.id} value={o.id}>
                                        {o.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="nec-block">
                        <div className="nec-header">Čistírna</div>
                        <div className="nec-control-left">
                            <input
                                type="checkbox"
                                checked={useCleanersSate}
                                disabled={stockId != null && stockId != ""}
                                onChange={(e) => setUseCleanersState(e.target.checked)}
                            />
                        </div>
                    </div>
                </>

                {error ? <div className="form-error">{error}</div> : null}
            </div>

            {actions?.length ? (
                <div className="item-list-actions">
                    <FloatingActions actions={actions} />
                </div>
            ) : null}
        </Card>
    );

};

export default StockCardOP;